// Navbar.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaHandHoldingHeart, FaBars, FaTimes } from "react-icons/fa";
import logo from "../Assests/lss_logo.png";
import "./Navbar.css";

export default function Navbar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  const navLinks = [
    { path: "/", label: t("Home") || "Home" },
    { path: "/about", label: t("About") || "About Us" },
    { path: "/annual", label: t("Annual_Report") || "Annual Report" },
    { path: "/provision", label: "80G/12A" },
    { path: "/certificate", label: t("Certification") || "Certification" },
    { path: "/gallery", label: t("Gallery") || "Gallery" },
    { path: "/event", label: t("Events") || "Events" },
    { path: "/media", label: t("Media") || "Media" },
    { path: "/contact", label: t("Contact_us") || "Contact Us" },
  ];

  return (
    <nav className={`main-navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-wrapper">
          {/* Logo */}
          <Link to="/" className="logo-wrapper">
            <img src={logo} alt="LSSF Trust Logo" className="navbar-logo" />
          </Link>

          {/* Desktop Navigation */}
          <div className="nav-links desktop-nav">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`nav-link ${isActive(link.path)}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Donate Button */}
          <button
            className="donate-btn"
            onClick={() => navigate("/whydonation")}
          >
            <FaHandHoldingHeart className="donate-icon" />
            <span>{t("Donate Now") || "Donate Now"}</span>
          </button>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${mobileMenuOpen ? 'open' : ''}`}>
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className={`mobile-nav-link ${isActive(link.path)}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <button
            className="mobile-donate-btn"
            onClick={() => {
              navigate("/whydonation");
              setMobileMenuOpen(false);
            }}
          >
            <FaHandHoldingHeart />
            <span>{t("Donate Now") || "Donate Now"}</span>
          </button>
        </div>
      </div>
    </nav>
  );
}